import { RecordMaskResource, Cache } from '@skinsoft/types'
import { Proxy } from '@skinsoft/network'
import { DataStore } from '@skinsoft/data-store/src/data-store'

export class RecordMaskDataStore extends DataStore<RecordMaskResource & { id: string }> {

    public static getInstance() {
        if (!RecordMaskDataStore.instance) {
            RecordMaskDataStore.instance = new RecordMaskDataStore();
        }

        return RecordMaskDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$recordMaskDataStore = RecordMaskDataStore.getInstance();
    }

    private static instance: RecordMaskDataStore = null as any;

    constructor(proxy?: Proxy, cache?: Cache<RecordMaskResource>) {
        super(`/record-masks`);
    }

    protected initializeDataFetcher() {
        //throw new Error('Method not implemented.');
    }

    protected initializeDataPusher() {
        //throw new Error('Method not implemented.');
    }

    // @ts-ignore
    public searchAll(searchQuery: SearchQuery, pathAndValueToCheck?: any, searchEndpointOverride: string | null = null, options: DataStoreOptions = {}, onlyOnLocallyCreated: boolean = false, forceSearchTextId: boolean = false) {
        throw new Error("This method is not implemented in this subclass")
        // logger
    }
}